import { render, staticRenderFns } from "./manuAssign.vue?vue&type=template&id=4a89a0ab&scoped=true&"
import script from "./manuAssign.vue?vue&type=script&lang=js&"
export * from "./manuAssign.vue?vue&type=script&lang=js&"
import style0 from "./manuAssign.vue?vue&type=style&index=0&id=4a89a0ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89a0ab",
  null
  
)

export default component.exports